import { render, staticRenderFns } from "./Iframes.vue?vue&type=template&id=e1f70f3a"
import script from "./Iframes.vue?vue&type=script&lang=js"
export * from "./Iframes.vue?vue&type=script&lang=js"
import style0 from "./Iframes.vue?vue&type=style&index=0&id=e1f70f3a&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports